import React from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import '../css/App.css';
import { Login } from './containers/Login';
import { Signup } from './containers/Signup';
import { RequireAuth } from './components/RequireAuth';
import { Home } from './containers/Home';
import { Todos } from './containers/Todos';
import { TodoDetail } from './containers/TodoDetail';
import { useCheckAuth } from './hooks/useCheckAuth';

function App() {
  const { isLoading, isLoggedIn } = useCheckAuth();

  if (isLoading) {
    return (
      <div
        style={{ height: '100vh', width: '100vw' }}
        className="column-flex align-center"
      >
        Loading...
      </div>
    );
  }

  return (
    <BrowserRouter basename="/first-page">
      <Routes>
        <Route
          path="/home"
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path="/todos"
          element={
            <RequireAuth>
              <Todos />
            </RequireAuth>
          }
        />
        <Route
          path="/todos/:id"
          element={
            <RequireAuth>
              <TodoDetail />
            </RequireAuth>
          }
        />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/home" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
